export default __webpack_public_path__ + "static/media/navbar.8c2cfe6d.svg";